import React, { useState, useEffect, useRef, forwardRef } from "react";
import { useForm, Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import useFetch from "../../../../../hooks/useFetch";
import { FormControl, FormHelperText } from "@mui/material";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import useFormattedLocalDate from "../../../../../hooks/useFormattedLocalDate";
import ModalShell from "../../../../shares/dashboard/ModalShell";

const FORM_ID = "edit-exam-form";

const AddVideos = forwardRef(({ close, get, edit }, ref) => {
  const [payload, setPayload] = useState();
  const [call, setCall] = useState({
    ExamName: "",
    exam_headline: "",
    exam_available_time_start: "",
    exam_available_time_end: "",
    exam_group: "",
    exam_maxenterance_time: "",
  });
  const formatDate = useFormattedLocalDate();

  const [gg, setGg] = useState();

  const newQuestion = useFetch({
    method: "POST",
    url: `management/exams/`,
    noHeader: false,
    trigger: false,
    data: payload,
    caller: get,
  });

  const editExam = useFetch({
    method: "PATCH",
    url: `management/exams/${edit}/`,
    noHeader: false,
    trigger: false,
    data: payload,
    caller: get,
  });

  const getExam = useFetch({
    method: "GET",
    url: `management/exams/${edit}/`,
    noHeader: false,
    trigger: edit ? true : false,
    setter: setCall,
  });

  const getGg = useFetch({
    method: "GET",
    url: `management/groups/?page_size=1000`,
    noHeader: false,
    trigger: true,
    setter: setGg,
  });

  const questionRef = useRef(null);
  const answerRef = useRef(null);

  const handleClickQuestion = () => {
    questionRef.current.click();
  };
  const handleClickAnswer = () => {
    answerRef.current.click();
  };

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: call,
  });

  const onSubmit = (e) => {
    const formData = new FormData();

    formData.append("ExamName", call.ExamName);
    formData.append("exam_headline", call.exam_headline);
    formData.append("exam_question_bank_id", call.exam_question_bank);
    formData.append("exam_group", call.exam_group);
    formData.append("exam_maxenterance_time", call.exam_maxenterance_time);
    formData.append(
      "exam_available_time_start",
      call.exam_available_time_start
    );
    formData.append("exam_available_time_end", call.exam_available_time_end);

    setPayload(formData);

    if (edit) {
      editExam.reFetch();
    } else {
      newQuestion.reFetch();
    }
  };
  useEffect(() => {
    newQuestion.status === 201 && close();
  }, [newQuestion.status]);
  useEffect(() => {
    editExam.status === 200 && close();
  }, [editExam.status]);

  const submitting = newQuestion.loading || editExam.loading;

  return (
    <ModalShell
      ref={ref}
      close={close}
      title="ویرایش آزمون"
      subtitle="عنوان، مبحث، گروه و زمان‌بندی آزمون"
      footer={
        <div className="flex justify-start">
          <button
            form={FORM_ID}
            type="submit"
            disabled={submitting}
            className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            {submitting ? "در حال ثبت…" : "ثبت تغییرات"}
          </button>
        </div>
      }
    >
      <form
        id={FORM_ID}
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-lg text-sm"
      >
        <div>
          <label htmlFor="ExamName" className="mb-2xs block text-sm text-ink-muted">
            عنوان
          </label>
          <TextField
            name="ExamName"
            value={call.question_headline}
            placeholder="عنوان"
            {...register("ExamName", {
              required: "عنوان را وارد کنید",
            })}
            error={!!errors.ExamName}
            helperText={errors.ExamName ? errors.ExamName.message : ""}
            onChange={(e) => {
              setCall({ ...call, ExamName: e.target.value });
            }}
            fullWidth
          />
        </div>

        <div>
          <label htmlFor="exam_headline" className="mb-2xs block text-sm text-ink-muted">
            مبحث
          </label>
          <FormControl error={errors.exam_headline ? true : false} fullWidth>
            <Select
              value={call.exam_headline}
              {...register("exam_headline", {
                required: "مبحث را وارد کنید",
              })}
              fullWidth
              onChange={(e) => {
                setCall({ ...call, exam_headline: e.target.value });
              }}
            >
              {lessons.map((lesson) => {
                return <MenuItem value={lesson}>{lesson}</MenuItem>;
              })}
            </Select>
            <FormHelperText>{errors?.exam_headline?.message}</FormHelperText>
          </FormControl>
        </div>
        <div>
          <label htmlFor="exam_group" className="mb-2xs block text-sm text-ink-muted">
            گروه
          </label>
          <FormControl error={errors.exam_group ? true : false} fullWidth>
            <Select
              value={call.exam_group}
              {...register("exam_group", {
                required: "مبحث را وارد کنید",
              })}
              fullWidth
              onChange={(e) => {
                setCall({ ...call, exam_group: e.target.value });
              }}
            >
              {gg?.results.map((g) => {
                return <MenuItem value={g.id}>{g.name}</MenuItem>;
              })}
            </Select>
            <FormHelperText>{errors?.exam_group?.message}</FormHelperText>
          </FormControl>
        </div>
        <div>
          <label htmlFor="start-day" className="mb-2xs block text-sm text-ink-muted">
            روز شروع
          </label>
          <FormControl
            error={errors.exam_available_time_start ? true : false}
            fullWidth
          >
            <Controller
              name="start-day"
              control={control}
              render={() => (
                <MobileDateTimePicker
                  label="روز شروع"
                  value={
                    call.exam_available_time_start
                      ? new Date(call.exam_available_time_start)
                      : null
                  }
                  onChange={(e) => {
                    const date = formatDate(e, "datetime");

                    setCall((prev) => {
                      return {
                        ...prev,
                        exam_available_time_start: date,
                      };
                    });
                  }}
                  views={["year", "month", "day", "hours", "minutes"]}
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                  className="w-full"
                  ampm={false}
                  slotProps={{
                    field: { shouldRespectLeadingZeros: true },
                    toolbar: { hidden: true },
                    tabs: { hidden: true },
                  }}
                  sx={{
                    "& .PrivatePickersClockNumber-clockNumber": {
                      fontSize: 50,
                    },
                  }}
                />
              )}
            />
            <FormHelperText>
              {errors?.assignment_available_time_start?.message}
            </FormHelperText>
          </FormControl>
        </div>
        <div>
          <label htmlFor="class" className="mb-2xs block text-sm text-ink-muted">
            پایان
          </label>
          <FormControl
            error={errors.exam_available_time_end ? true : false}
            fullWidth
          >
            <Controller
              name="end-day"
              control={control}
              render={() => (
                <MobileDateTimePicker
                  label="روز پایان"
                  value={
                    call.exam_available_time_end
                      ? new Date(call.exam_available_time_end)
                      : null
                  }
                  onChange={(e) => {
                    const date = formatDate(e, "datetime");

                    setCall((prev) => ({
                      ...prev,
                      exam_available_time_end: date,
                    }));
                  }}
                  // onChange={}
                  views={["year", "month", "day", "hours", "minutes"]}
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                  className="w-full"
                  ampm={false}
                  slotProps={{
                    field: { shouldRespectLeadingZeros: true },
                    toolbar: { hidden: true },
                    tabs: { hidden: true },
                  }}
                  sx={{
                    "& .PrivatePickersClockNumber-clockNumber": {
                      fontSize: 50,
                    },
                  }}
                />
              )}
            />
            <FormHelperText>
              {errors?.assignment_available_time_start?.message}
            </FormHelperText>
          </FormControl>
        </div>
        <div>
          <label htmlFor="exam_maxenterance_time" className="mb-2xs block text-sm text-ink-muted">
            زمان ورود مجاز آزمون
          </label>
          <FormControl
            error={errors.exam_maxenterance_time ? true : false}
            fullWidth
          >
            <Controller
              name="max-day"
              control={control}
              render={() => (
                <MobileDateTimePicker
                  label="زمان ورود مجاز آزمون"
                  value={
                    call.exam_maxenterance_time
                      ? new Date(call.exam_maxenterance_time)
                      : null
                  }
                  onAccept={(e) => {
                    const date = formatDate(e, "datetime");

                    setCall((prev) => ({
                      ...prev,
                      exam_maxenterance_time: date,
                    }));
                  }}
                  views={["year", "month", "day", "hours", "minutes"]}
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                  className="w-full"
                  ampm={false}
                  slotProps={{
                    field: { shouldRespectLeadingZeros: true },
                    toolbar: { hidden: true },
                    tabs: { hidden: true },
                  }}
                  sx={{
                    "& .PrivatePickersClockNumber-clockNumber": {
                      fontSize: 50,
                    },
                  }}
                />
              )}
            />
            <FormHelperText>
              {errors?.exam_maxenterance_time?.message}
            </FormHelperText>
          </FormControl>
        </div>

      </form>
    </ModalShell>
  );
});

export default AddVideos;

const lessons = [
  "توابع و خواص آن ها",
  "معادله درجه دوم",
  "الگو و دنباله",
  "مثلثات",
  "توان های گویا و عبارات جبری",
  "مرور توابع و خواص آن ها",
  "آنالیز",
  "احتمالات",
  "هندسه مختصاتی",
  "معادلات و نامعادلات گویا و گنگ",
  "قدر مطلق",
  "براکت",
  "هندسه",
  "توابع نمایی و لگاریتم",
  "حد",
  "پیوستگی",
  "بخش پذیری",
  "مشتق",
  "کاربرد مشتق",
  "مجانب ها",
  "مقاطع مخروطی",
];
